/**
 * Where users land after signing in — the `/` home. It's an empty placeholder
 * for now (the app has no default feature section), so sign-in no longer
 * auto-forwards into `/raw-footage`.
 */
export const POST_LOGIN_REDIRECT = '/' as const;
export const AUTH_SUPPORT_EMAIL = 'support@thevisionlab.ai';
export const MIN_PASSWORD_LENGTH = 6;

/** Query-key root for the caller's authorization data — cleared on sign-out. */
export const MY_PERMISSIONS_KEY = 'authz' as const;

/** Query-key prefixes for the two current-user authorization contracts. */
export const AVAILABLE_OPERATIONS_KEY = [MY_PERMISSIONS_KEY, 'available-operations'] as const;
export const TARGET_OPERATIONS_KEY = [MY_PERMISSIONS_KEY, 'target-operations'] as const;
export const PERMISSION_TARGET_BATCH_SIZE = 100;

/**
 * How long fetched permissions are considered fresh. Bindings change rarely; the
 * global 403 handler covers the gap when an admin change lands mid-session.
 */
export const PERMISSIONS_STALE_TIME = 5 * 60_000;
